import { render } from "./AutoModal.vue?vue&type=template&id=4237b83b&scoped=true&ts=true"
import script from "./AutoModal.vue?vue&type=script&lang=ts"
export * from "./AutoModal.vue?vue&type=script&lang=ts"

import "./AutoModal.vue?vue&type=style&index=0&id=4237b83b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4237b83b"]])

export default __exports__